import { Entity } from './Entity'

export class Location extends Entity {
	constructor (payload, api) {
		super(Object.assign({}, payload, {type:"location"}), api);
	}

	/**
	 * Determine location visibility
	 *
	 * @arg other Another entity
	 *
	 * Locations are visible by those with permission
	 * "driver" and above.
	 *
	 */
	isVisibleBy (other) {
		const acceptablePermissions = [ "driver", "operator", "manager", "admin", "master" ];

		if (super.isVisibleBy(other)) {
			if (other.permissions) {
				if (acceptablePermissions.filter( p => other.permissions.includes(p) ).length > 0) {
					return true;
				}
			}
		}
		return false;
	}

	/**
	 * Determine if a location is editable by another entity
	 *
	 * @arg other Another entity
	 *
	 * Locations are editable by those with permissions
	 * "manager", "admin" or "master".
	 *
	 */
	isEditableBy (other) {
		const acceptablePermissions = [ "manager", "admin", "master" ];

		if (super.isEditableBy(other)) {
			if (other.permissions) {
				if (acceptablePermissions.filter( p => other.permissions.includes(p) ).length > 0) {
					return true;
				}
			}
		}
		return false;
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/JMan/Entity/Location.js